// extracted by css-extract-rspack-plugin
export default {"size40":"40px","size400":"400px","sizeFluid":"100%","resetSection":"forgot-container__resetSection___oglLb","containerContent":"forgot-container__containerContent___pibNA"};